import { render } from "./AutorespondersView.vue?vue&type=template&id=ef02a40a&ts=true"
import script from "./AutorespondersView.vue?vue&type=script&lang=ts"
export * from "./AutorespondersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__